import { styled } from '@mui/material'
import { Inbox as CourierInbox } from '@trycourier/react-inbox'
import { Toast } from '@trycourier/react-toast'
import React from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

const StyledCourierInbox = styled(CourierInbox, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})(({ theme }) => ({
  '& path': {
    fill: `${theme.palette.grey['600']} !important`,
  },
  '& [class*="UnreadIndicator"]': {
    padding: '4px !important',
    background: `${theme.palette.green['500']} !important`,
    outline: `2px solid ${theme.palette.grey['100']} !important`,
  },
}))

export const NotificationInbox: React.FC = () => {
  const userData = useAuthenticatedUser()

  if (userData.isFullyAuthenticated && !userData.user.isSupplier) return <StyledCourierInbox openLinksInNewTab={false} />
  return null
}
export const NotificationToast: React.FC = () => {
  const userData = useAuthenticatedUser()
  if (userData.isFullyAuthenticated && !userData.user.isSupplier) return <Toast />
  return null
}
